import React, { Component } from "react";
import { Popover, Menu } from "material-ui";
import { selectStyles } from "./styles/style";
import { SlideInDownAnimation } from "./Animation";

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = { anchorEl: undefined };
  }

  handleClick = event => {
    // This prevents ghost click.
    event.preventDefault();
    this.props.onToggle(true);
  };

  renderText = () => {
    const { text, value, placeholder } = this.props;
    if (value === "") {
      return (
        <span style={selectStyles.hintTextStyle}>
          {placeholder}
          <i className="material-icons" style={selectStyles.iconStyle}>
            keyboard_arrow_down
          </i>
        </span>
      );
    } else {
      return <span style={selectStyles.valueStyle}>{text}</span>;
    }
  };

  handleRef = span => {
    if (span) {
      this.setState({ anchorEl: span });
    }
  };

  render() {
    const Animation = this.props.reload ? SlideInDownAnimation : "span";
    return (
      <Animation>
        <span
          style={selectStyles.containerStyle}
          onClick={this.handleClick}
          ref={this.handleRef}
        >
          {this.renderText()}
          <Popover
            {...this.props}
            open={this.props.open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{ horizontal: "left", vertical: "top" }}
            targetOrigin={{ horizontal: "left", vertical: "top" }}
            onRequestClose={() => this.props.onToggle(false)}
          >
            <Menu maxHeight={350} className="menu-option" autoWidth>
              {this.props.children}
            </Menu>
          </Popover>
          <span style={selectStyles.bottomLineStyle} />
        </span>
      </Animation>
    );
  }
}

export { Select };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/Select.js